/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowGroupMeditationDayTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowGroupMeditationDay,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Let’s Meditate Together!",
    "Group Meditation Day Awaits!",
    "Find Inner Peace as a Community!",
  ],
  title: "Group Meditation Day",
  description: "Organize a fun group meditation day.",
  longDescription:
    "Gather your community for an exciting meditation day! Choose a date, decide on meditation styles, and plan refreshments!",
  emoji: "🧘",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Woodworker,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Group Meditation Day",
          emoji: "🧘",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we hold the group meditation day?",
          emoji: "📅",
          completeAction: {
            question: "Decide on meditation styles to practice?",
            description: "What styles should we focus on during the day?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What styles should we consider?",
                emoji: "🧘",
                completeAction: {
                  question: "Decide on refreshments?",
                  description: "What refreshments should we plan for the day?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What refreshments should we bring?",
                      emoji: "🍵",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Let’s Meditate Together!",
    outroDescription:
      "Your group meditation day plans are set! Enjoy the tranquility!",
  },
};
